import React from 'react'
import _ from 'lodash'

import {TokenStore, TokenService} from '../api/tokens'

export class TokensStorage extends React.Component {
   static get propTypes() {
      return {
         children: React.PropTypes.node.isRequired,
         filter:   React.PropTypes.func
      }
   }

   constructor() {
      super()

      this.state = {tokens: null, loading: false}
      this._mounted = false
   }

   componentDidMount() {
      this._mounted = true

      this.loadTokens()

      TokenStore.addChangeListener(
         (this._listener = () => {
            if (this._mounted) {
               this.setState({tokens: TokenStore.tokens})
            }
         }),
      )
   }

   loadTokens() {
      this.setState({loading: true})
      TokenService.fetchTokens().done(() => this.setState({loading: false}))
   }

   componentWillUnmount() {
      this._mounted = true

      TokenStore.removeChangeListener(this._listener)
   }

   render() {
      const {children, filter, ...props} = this.props
      let {tokens, loading} = this.state

      if (filter) {
         tokens = _.filter(tokens, filter)
      }

      return React.cloneElement(children, _.assign({}, props, {tokens: tokens || [], loading}))
   }
}



// WEBPACK FOOTER //
// lib/storage/Token.jsx